import React from 'react';
import { Box } from '@mui/material';
import Navbar from './Navbar';

const Header = ({ onAgentClick }) => {
  return (
    <Box  sx={{ position: 'relative',  maxWidth: '99vw', width: '99vw', margin: '0 auto' }}>
      <Navbar onAgentClick={onAgentClick} />
      <Box />
    </Box>
  );
};

export default Header;